var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMerci(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 76.6 80.4",
    style: {
      enableBackground: "new 0 0 76.6 80.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M37.2,79.8c-14.7,0-26.6-12.1-26.6-27.1h10.9c0,8.9,7.1,16.2,15.7,16.2s15.7-7.3,15.7-16.2h10.9 C63.8,67.7,51.9,79.8,37.2,79.8z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M19.5,14.7v16.7h-4.1v-10l-3.7,10H8.5l-3.8-10v10H0.6V14.7h4.8l4.7,11.5l4.6-11.5H19.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M26.5,17.9v3.4H32v3.1h-5.4v3.7h6.2v3.3H22.4V14.7h10.2v3.3H26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M43.8,31.4l-3.5-6.3h-1v6.3h-4.1V14.7h6.8c1.3,0,2.4,0.2,3.4,0.7c0.9,0.5,1.6,1.1,2.1,1.9c0.5,0.8,0.7,1.7,0.7,2.7 c0,1.1-0.3,2.1-0.9,3c-0.6,0.9-1.5,1.5-2.8,1.9l3.8,6.6H43.8z M39.4,22.2h2.5c0.7,0,1.3-0.2,1.7-0.5s0.6-0.9,0.6-1.5 c0-0.6-0.2-1.1-0.6-1.5s-0.9-0.5-1.7-0.5h-2.5V22.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M51.2,18.6c0.7-1.3,1.7-2.3,3-3s2.7-1.1,4.3-1.1c2,0,3.7,0.5,5.1,1.6c1.4,1,2.4,2.5,2.8,4.3h-4.5c-0.3-0.7-0.8-1.2-1.4-1.6 s-1.3-0.5-2.1-0.5c-1.3,0-2.3,0.4-3,1.3c-0.8,0.9-1.2,2-1.2,3.5s0.4,2.6,1.2,3.5c0.8,0.9,1.8,1.3,3,1.3c0.8,0,1.5-0.2,2.1-0.5 s1.1-0.9,1.4-1.6h4.5c-0.5,1.8-1.4,3.2-2.8,4.3c-1.4,1-3.1,1.6-5.1,1.6c-1.6,0-3.1-0.4-4.3-1.1s-2.3-1.7-3-3 c-0.7-1.3-1.1-2.7-1.1-4.4C50.1,21.3,50.5,19.9,51.2,18.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M72.9,14.7v16.7h-4.1V14.7H72.9z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M76.1,5.2c0,2.6-2.1,4.6-4.6,4.6c-2.6,0-4.6-2.1-4.6-4.6s2.1-4.6,4.6-4.6C74,0.5,76.1,2.6,76.1,5.2 C76.1,5.2,76.1,5.2,76.1,5.2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerci);
export default __webpack_public_path__ + "static/media/merci.164a7ca2d9b463d57a3482045387f36e.svg";
export { ForwardRef as ReactComponent };